import _implicitStylesheets from "./additionalDetails.css";
import _implicitScopedStylesheets from "./additionalDetails.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="title${0}"${2}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<p class="details${0}" type-style="body-2"${2}>${"t1"}</p>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  return [$cmp.details ? api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.title))]) : null, $cmp.details ? api_static_fragment($fragment2, 3, [api_static_part(1, null, api_dynamic_text($cmp.details))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6kvab6mgbb4";
tmpl.legacyStylesheetToken = "undefined-_additionalDetails";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
